import { Timestamp } from 'firebase/firestore'
import { User } from 'firebase/auth'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const appendWithUserId = (data: any, user: User) => {
  return {
    ...data,
    userId: user?.uid,
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const appendWithCreatedAt = (data: any) => {
  return {
    ...data,
    createdAt: Timestamp.now(),
  }
}

/** Sorts an array by a string key using numeric-aware comparison (does not mutate original). */
export function sortByNumericString<T>(arr: T[], key: string): T[] {
  return [...arr].sort((a: unknown, b: unknown) => {
    const keyA = (a as Record<string, unknown>)[key] ?? ''
    const keyB = (b as Record<string, unknown>)[key] ?? ''
    return String(keyA).localeCompare(String(keyB), undefined, { numeric: true, sensitivity: 'base' })
  })
}
